import { render, staticRenderFns } from "./login-form.vue?vue&type=template&id=6e00726a&"
import script from "./login-form.component.ts?vue&type=script&lang=ts&"
export * from "./login-form.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/leochen/Documents/Interact_Technology/HealthAgent/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e00726a')) {
      api.createRecord('6e00726a', component.options)
    } else {
      api.reload('6e00726a', component.options)
    }
    module.hot.accept("./login-form.vue?vue&type=template&id=6e00726a&", function () {
      api.rerender('6e00726a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/account/login-form/login-form.vue"
export default component.exports